import React from 'react'
import Icon from 'react-icon-base'

const StarIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m20 28.8l-10.3 6.2 2.7-11.7-9-7.9 11.9-1 4.7-11 4.7 11 11.9 1-9 7.9 2.7 11.7z" />
    </g>
  </Icon>
)

export default StarIcon
